var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  "+_vm._s(_vm.$t('topBar.status'))+"\n  "),_c('span',{staticClass:"ml-2 p-1 badge bg-danger text-white font-size-12 text-uppercase"},[_vm._v("Trialing")])])}
var staticRenderFns = []

export { render, staticRenderFns }